import '../index.css';

import * as Sentry from '@sentry/react';
import { OpenAPI } from 'api-clients/monolith';
import { LanguageProvider } from 'i18n/LanguageProvider';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import { AppContextProvider } from 'components/app-context-provider';
import { FeatureFlagContextProvider } from 'components/feature-flag-context-provider';
import { domainMeta } from 'utils/domainMeta';
import { initSentry } from 'utils/sentry';

import { Root } from './root';

// Before the first render, so a failure during bootstrap is reported.
initSentry();

const MOUNT_NODE = document.getElementById('app');
OpenAPI.BASE = domainMeta.monolithOrigin;
OpenAPI.WITH_CREDENTIALS = true;

createRoot(MOUNT_NODE).render(
  <React.StrictMode>
    {/*
      A render error already blanks the directory out, because React unmounts
      the tree it cannot recover. The boundary keeps that behavior — no
      `fallback`, so it renders nothing — and adds the report React does not
      send.
    */}
    <Sentry.ErrorBoundary>
      <Router>
        <LanguageProvider>
          <FeatureFlagContextProvider>
            <AppContextProvider>
              <div className="flex min-h-screen flex-col">
                <Root />
              </div>
            </AppContextProvider>
          </FeatureFlagContextProvider>
        </LanguageProvider>
      </Router>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
